module.exports = __webpack_public_path__ + "img/bar2_2.27ac98ed.png";